import { render, staticRenderFns } from "./children-detail.vue?vue&type=template&id=afa39a7c&"
import script from "./children-detail.vue?vue&type=script&lang=js&"
export * from "./children-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports